import React, { Suspense, useLayoutEffect, useMemo, useRef, useState } from "react";
import { Outlet, useLocation } from "react-router-dom";
import { PeekBox, PeekScreenLoader, PeekStack } from "@piiqtechnologies/ui-components";
import { AppSidebar } from "@components/common/app-sidebar";
import { DiscoverWhatsNew } from "@stores/DiscoverWhatsNew";
import { SidebarNavProvider } from "@stores/SidebarNavContext";
import { SubjectReportsProvider } from "@stores/SubjectReportsContext";
import { AppShellContext } from "./AppShellContext";
export const DashboardLayout = () => {
    const scrollContainerRef = useRef(null);
    const [headerSlot, setHeaderSlot] = useState(null);
    const appShell = useMemo(() => ({ scrollContainerRef, headerSlot }), [headerSlot]);
    // One container scrolls every page, so a new page inherited the last one's offset: a community
    // opened from low on the portfolio landed 1,480px down, where its section nav read the offset as
    // the competitors section and wrote #competitors (DISCOVER-1073). A layout effect runs before
    // the page's own effects, so its scroll-spy and deep-link jump start from the top. It only
    // sticks because of the Suspense below.
    const { pathname } = useLocation();
    useLayoutEffect(() => {
        if (scrollContainerRef.current)
            scrollContainerRef.current.scrollTop = 0;
    }, [pathname]);
    return (React.createElement(AppShellContext.Provider, { value: appShell },
        React.createElement(SidebarNavProvider, null,
            React.createElement(SubjectReportsProvider, null,
                React.createElement(DiscoverWhatsNew, null,
                    React.createElement(PeekStack, { direction: "row", sx: { width: "100%", height: "100vh" } },
                        React.createElement(AppSidebar, null),
                        React.createElement(PeekStack, { sx: { p: 3, flex: 1, minHeight: 0, backgroundColor: "grey.50" } },
                            React.createElement(PeekBox, { ref: setHeaderSlot }),
                            React.createElement(PeekBox, { ref: scrollContainerRef, sx: { flex: 1, minHeight: 0, overflowY: "auto", scrollbarWidth: "auto", pr: "10px" } },
                                React.createElement(Suspense, { fallback: React.createElement(PeekScreenLoader, { layered: true }) },
                                    React.createElement(Outlet, null))))))))));
};
export default DashboardLayout;
